module.exports = __webpack_public_path__ + "img/20200618_221155.b3c107ac.jpg";